import { getDevice, getDevices } from '../../api/devices';
import { Device } from '../../interfaces/api/device';

export async function fetchDevices(): Promise<Device[]> {
	try {
		return await getDevices();
	} catch (error) {
		throw error;
	}
}

export async function fetchDevice(id: number): Promise<Device> {
	try {
		return await getDevice(id);
	} catch (error) {
		throw error;
	}
}
